import React from "react";

import Icon from "@ant-design/icons";
import CommentsIcon from "@src/assets/icons/comments.svg";
import InfoIcon from "@src/assets/icons/info.svg";
import { CommentsOverview } from "@src/components/comments_overview/index";
import { RoleRequestBaseModal } from "@src/components/modals/role_request_modal/index";
import { ROLES } from "@src/constants";
import { ActionHandlers } from "@src/features/role_request_details/components/action_handlers/index";
import { OverviewTab } from "@src/features/role_request_details/components/overview_tab/index";
import {
  setCurrentResourcePlanRequestDetailTab,
  setResourcePlanDetailsModalVisibility,
} from "@src/services/slices/resourcePlanModalSlice";
import { useGetNoteQuery } from "@src/services/apis/notesApi";
import { useGetRoleRequestByIdQuery } from "@src/services/apis/projectRoleRequestsApi";
import { RootState, useAppSelector } from "@src/setupStore";
import { CustomTabItem } from "@src/types/antd_types";
import { useDispatch } from "react-redux";

const RoleRequestDetailsModal: React.FC = () => {
  const dispatch = useDispatch();

  // States
  const {
    resourcePlanModalVisible,
    selectedResourcePlanRequestId,
    currentTab,
  } = useAppSelector((state: RootState) => state.resourcePlanDetailsModalSlice);

  // RTK Queries
  const { data: request, isFetching } = useGetRoleRequestByIdQuery(
    selectedResourcePlanRequestId,
    {
      skip: !selectedResourcePlanRequestId,
    }
  );

  const { data: notes } = useGetNoteQuery(selectedResourcePlanRequestId, {
    skip: !selectedResourcePlanRequestId,
  });

  const tabs: CustomTabItem[] = [
    {
      key: "0",
      icon: <Icon component={InfoIcon} />,
      label: `Overview`,
      children: <OverviewTab request={request} />,
    },
    {
      key: "1",
      icon: <Icon component={CommentsIcon} />,
      label: `Comments (${notes?.length})`,
      children: <CommentsOverview requestId={request?.roleRequestId} />,
    },
  ];

  return (
    <div>
      {!isFetching && (
        <RoleRequestBaseModal
          activeTabKey={currentTab}
          handleClose={() => {
            dispatch(setResourcePlanDetailsModalVisibility(false));
          }}
          handleTabChange={(key: string) =>
            dispatch(setCurrentResourcePlanRequestDetailTab(key))
          }
          modalVisible={resourcePlanModalVisible}
          tabs={tabs}
          actions={<ActionHandlers request={request} />}
          requestId={request?.roleRequestId}
          requestStatus={request?.status}
          standardRoleName={request?.standardRoleName}
          isRequestOutdated={request?.isOutdated}
          userRole={ROLES.PROJECT_LEAD}
        />
      )}
    </div>
  );
};

export default RoleRequestDetailsModal;
